import * as actionTypes from './actionTypes';

export const initializeQSA = (payload) => ({ type: actionTypes.INITIALIZE, payload });
export const initializeQSASuccess = () => ({
  type: actionTypes.INITIALIZE_SUCCESS,
});
export const initializeQSAFailure = (payload) => ({
  type: actionTypes.INITIALIZE_FAILURE,
  payload,
});

export const submitQSA = (payload) => ({ type: actionTypes.SUBMIT, payload });
export const submitQSASuccess = (payload) => ({ type: actionTypes.SUBMIT_SUCCESS, payload });
export const submitQSADataFailure = (payload) => ({ type: actionTypes.SUBMIT_FAILURE, payload });

export const confirmQSA = (payload) => ({ type: actionTypes.CONFIRM, payload });
export const confirmQSASuccess = (payload) => ({ type: actionTypes.CONFIRM_SUCCESS, payload });
export const confirmQSADataFailure = (payload) => ({ type: actionTypes.CONFIRM_FAILURE, payload });

export const resetQSA = () => ({ type: actionTypes.RESET });
